import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Building2, MapPin, Check } from "lucide-react";
import { useActiveLocation } from "@/contexts/ActiveLocationContext";
import { cn } from "@/lib/utils";

export function CenterSwitcherDialog() {
  const { showCenterPicker, userLocations, activeLocationId, setActiveLocation, closeCenterPicker } = useActiveLocation();

  return (
    <Dialog open={showCenterPicker} onOpenChange={(open) => { if (!open) closeCenterPicker(); }}>
      <DialogContent
        className="sm:max-w-md [&>button]:hidden"
        onPointerDownOutside={(e) => { if (!activeLocationId) e.preventDefault(); }}
        onEscapeKeyDown={(e) => { if (!activeLocationId) e.preventDefault(); }}
      >
        <DialogHeader className="text-center">
          <div className="mx-auto h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-2">
            <Building2 className="h-6 w-6 text-primary" />
          </div>
          <DialogTitle className="text-xl">Select Your Centre</DialogTitle>
          <DialogDescription>
            You're assigned to multiple centres. Choose which centre you'd like to work at for this session.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-3 mt-4">
          {userLocations.map((loc) => {
            const isActive = loc.location_id === activeLocationId;
            return (
              <Button
                key={loc.location_id}
                variant="outline"
                className={cn(
                  "h-auto p-4 flex items-center gap-4 justify-start transition-all",
                  isActive
                    ? "border-primary bg-primary/5 ring-2 ring-primary/20"
                    : "hover:bg-primary/5 hover:border-primary"
                )}
                onClick={() => setActiveLocation(loc.location_id)}
              >
                <div className={cn(
                  "h-10 w-10 rounded-full flex items-center justify-center shrink-0",
                  isActive ? "bg-primary text-primary-foreground" : "bg-muted"
                )}>
                  {isActive ? <Check className="h-5 w-5" /> : <MapPin className="h-5 w-5 text-muted-foreground" />}
                </div>
                <div className="text-left">
                  <div className="font-semibold">{loc.name}</div>
                  {loc.state && (
                    <div className="text-sm text-muted-foreground">{loc.state}</div>
                  )}
                </div>
              </Button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
